<template>
  <div class="home-side-menu-wrap" :class="{ is_fixed: isFixed }" id="boxFixed">
    <a-menu
      mode="inline"
      style="width: 133px"
      v-model="selectedKeys"
      :default-open-keys="['1']"
      @openChange="onOpenChange"
      class="home-side-menu-item-wrap"
    >
      <template v-for="item in menuList">
        <a-menu-item
          v-if="!item.childrenList"
          :key="item.id"
          @click="handleClick(item.title)"
        >
          {{ item.title }}
        </a-menu-item>
        <a-sub-menu v-else :key="item.id">
          <span slot="title"
            ><span>{{ item.title }}</span></span
          >
          <a-menu-item
            v-for="items in item.childrenList"
            :key="items.name"
            @click="handleClick(items.name)"
          >
            {{ items.name }}
          </a-menu-item>
        </a-sub-menu>
      </template>
    </a-menu>
  </div>
</template>
<script>
import { menuList } from './configs/config'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      menuList,
      rootSubmenuKeys: ['1', '2', '3', '4'],
      selectedKeys: [''],
      isFixed: false,
      offsetTop: 0
    }
  },
  computed: {
    ...mapGetters('headerMenu', ['stateSelectedKeys'])
  },
  mounted() {
    window.addEventListener('scroll', this.initHeight)
    this.$nextTick(() => {
      // 获取对象相对于版面或由 offsetTop 属性指定的父坐标的计算顶端位置
      this.offsetTop = document.querySelector('#boxFixed').offsetTop
    })
  },
  // 回调中移除监听
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  watch: {
    // 侦听器导航菜单已选项的变化
    stateSelectedKeys: {
      handler: function (newVal) {
        if (newVal == '资源导航') {
          this.selectedKeys = ['4']
        } else {
          this.selectedKeys = []
        }
      },
      immediate: true
    }
  },
  methods: {
    initHeight() {
      // 设置或获取位于对象最顶端和窗口中可见内容的最顶端之间的距离 (被卷曲的高度)
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      // 如果被卷曲的高度大于吸顶元素到顶端位置 的距离
      this.isFixed = scrollTop > this.offsetTop
    },
    onOpenChange(openKeys) {
      const latestOpenKey = openKeys.find(
        (key) => this.selectedKeys.indexOf(key) === -1
      )
      if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
        this.openKeys = openKeys
      } else {
        this.openKeys = latestOpenKey ? [latestOpenKey] : []
      }
    },
    handleClick(val) {
      // console.log(val);
      this.$emit('handleClick', val)
    }
  }
}
</script>
